export default {
  brigade_works: [],
  all_brigade_works: [],


  brigade_work_categories: [],
  all_brigade_work_categories: [],

  
  productsList: {results: []}
}
